import { render } from "./TabsPage.vue?vue&type=template&id=5a8c991f"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marcpagesllorens/Projectes/motor-lescala-lloguer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__